/**
 * Cookie操作のユーティリティ関数
 */

/**
 * Cookieの値を取得
 * @param {string} name Cookie名
 * @returns {string|null} Cookieの値、存在しない場合はnull
 */
export function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    let [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

/**
 * Cookieを設定
 * @param {string} name Cookie名
 * @param {string} value Cookie値
 * @param {number} days 有効期限（日数、デフォルト30日）
 */
export function setCookie(name, value, days = 30) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
}

/**
 * Cookieを削除
 * @param {string} name Cookie名
 */
export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
}
